import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useValidateEmail } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useValidateEmail/useValidateEmail';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function useValidateKontaktEmail() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const [validateEmail] = useValidateEmail();

  const validate = async ({ email }: { email: string | null }) => {
    if (!email) {
      form.setFieldMeta('person.kontakt.email', (prev) => ({
        ...prev,
        isTouched: true,
        warnings: undefined,
      }));
      return;
    }
    const res = await validateEmail({ email });

    if (
      res.data?.Anlageassistent_validateEmail.findings.find(
        (finding) =>
          finding.__typename ===
          'mitarbeiter_MitarbeiterEmailCheckFindingBlacklist',
      )
    ) {
      form.setFieldMeta('person.kontakt.email', (prev) => ({
        ...prev,
        isTouched: true,
        warnings: [
          {
            message: t(
              'domain.mitarbeiter.create.steps.person.kontakt.form.email.validationBlacklist',
            ),
          },
        ],
      }));
    } else {
      form.setFieldMeta('person.kontakt.email', (prev) => ({
        ...prev,
        isTouched: true,
        warnings: undefined,
      }));
    }
    form.setFieldValue('person.kontakt.email', email);
  };

  // Revalidiert den bestehenden Wert, z.B. wenn das Feld an anderer Stelle erneut angezeigt wird.
  useEffect(() => {
    const email = form.state.values.person.kontakt.email;
    validate({ email });
  });

  return { validate };
}
